import { Loading } from '@components/loadling';
import { initSdk, onApiError } from '@proccess/api';
import { notistackRef } from '@proccess/ref/noti';
import { PayloadAction } from '@reduxjs/toolkit';
import { actions } from '@store/reducer';
import { AxiosResponse } from 'axios';
import Router from 'next/router';
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';

function* requestSubjects({
  payload: { page, limit = 20 },
}: PayloadAction<{ page?: number; limit?: number }>) {
  try {
    Loading.Show();
    const { data }: AxiosResponse = yield call(() =>
      initSdk.get('/admin/subjects', {
        params: {
          page,
          limit,
        },
      })
    );

    if (data) {
      yield put(actions.saveSubjects({ list: { ...data, limit } }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestSubjects() {
  yield takeEvery(actions.requestSubjects, requestSubjects);
}

function* requestSubject({ payload: { id } }: any) {
  try {
    Loading.Show();
    const { data }: AxiosResponse = yield call(() => initSdk.get(`/admin/subjects/${id}`));

    if (data) {
      yield put(actions.saveSubject({ data: data.Subject }));
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestSubject() {
  yield takeLatest(actions.requestSubject, requestSubject);
}

function* updateSubject({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const rs: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/subjects/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (rs.data) {
      yield put(actions.saveSubject({ data: rs.data }));
      yield call(() =>
        notistackRef.current?.enqueueSnackbar('Cập nhật thành công', { variant: 'success' })
      );
    }
  } catch (error) {
    onApiError(error);
  }
}

function* watcherupdateSubject() {
  yield takeLatest(actions.updateSubject, updateSubject);
}

function* createSubject({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const rs: AxiosResponse = yield call(() =>
      initSdk.post('/admin/subjects', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (rs.data) {
      yield put(actions.saveSubject({ data: rs.data }));
      yield call(() =>
        notistackRef.current?.enqueueSnackbar('Tạo mới thành công', { variant: 'success' })
      );
    }
  } catch (error) {
    onApiError(error);
  }
}

function* watcherCreateSubject() {
  yield takeLatest(actions.createSubject, createSubject);
}

function* deleteSubject({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const rs: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/subjects/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (rs?.data) {
      yield call(() =>
        notistackRef.current?.enqueueSnackbar('Xoá thành công !', { variant: 'success' })
      );
      Router.back();
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherDeleteSubject() {
  yield takeLatest(actions.deleteSubject, deleteSubject);
}

const subjectSagas = function* root() {
  yield all([
    fork(watcherRequestSubjects),
    fork(watcherRequestSubject),
    fork(watcherupdateSubject),
    fork(watcherCreateSubject),
    fork(watcherDeleteSubject),
  ]);
};
export { subjectSagas };
